import type { ReactNode } from "react";
import { motion } from "motion/react";
import { rise, staggerParent } from "../ui";

/**
 * Fades and lifts its children in the first time they scroll into view. Landing only; the app never animates on scroll,
 * so with `inView` off they rise in on mount.
 */
export function Reveal({
  children,
  className,
  gap = 0.08,
  as = "div",
  inView = true,
}: {
  children: ReactNode;
  className?: string;
  gap?: number;
  as?: "div" | "section" | "ol";
  inView?: boolean;
}) {
  const M = motion[as];
  const show = inView ? { whileInView: "show", viewport: { once: true, margin: "0px 0px -12% 0px" } } : { animate: "show" };
  return (
    <M className={className} variants={staggerParent(gap)} initial="hidden" {...show}>
      {children}
    </M>
  );
}

export function Item({ children, className, as = "div" }: { children: ReactNode; className?: string; as?: "div" | "li" | "h2" | "figure" }) {
  const M = motion[as];
  return (
    <M className={className} variants={rise}>
      {children}
    </M>
  );
}
